import React from 'react';
import { Navigate } from "react-router-dom";

export default function LoginFirst() {
  return (
    <div>
      <Navigate to="/login" state={{info: "Email驗證成功!"}} />
    </div>
  )
}